import { createAction, props } from '@ngrx/store';
import {
  IFileUploadRequest,
  IFileUploadResponse,
  IFileUploadProgress,
  IFileUploadError,
} from '../../models/fileupload.model';

// Generate Presigned URL Actions
const generatePresignedUrl = createAction(
  '[File Upload] Generate Presigned URL',
  props<{ request: IFileUploadRequest; file: File }>()
);

const generatePresignedUrlSuccess = createAction(
  '[File Upload] Generate Presigned URL Success',
  props<{ response: IFileUploadResponse; file: File }>()
);

const generatePresignedUrlFailure = createAction(
  '[File Upload] Generate Presigned URL Failure',
  props<{ error: IFileUploadError }>()
);

// Upload File Actions
const uploadFileToS3 = createAction(
  '[File Upload] Upload File to S3',
  props<{ presignedUrl: string; file: File; requestId: string; url: string }>()
);

const uploadFileToS3Progress = createAction(
  '[File Upload] Upload File to S3 Progress',
  props<{ progress: IFileUploadProgress }>()
);

const uploadFileToS3Success = createAction(
  '[File Upload] Upload File to S3 Success',
  props<{ requestId: string; key: string, url :string }>()
);

const uploadFileToS3Failure = createAction(
  '[File Upload] Upload File to S3 Failure',
  props<{ error: IFileUploadError }>()
);

// Complete Upload Process Actions
const uploadFile = createAction(
  '[File Upload] Upload File',
  props<{ request: IFileUploadRequest; file: File }>()
);

const uploadFileSuccess = createAction(
  '[File Upload] Upload File Success',
  props<{ requestId: string; key: string; fileName: string; url: string }>()
);

const uploadFileFailure = createAction(
  '[File Upload] Upload File Failure',
  props<{ error: IFileUploadError }>()
);

// Clear Actions
const clearUploadError = createAction(
  '[File Upload] Clear Upload Error',
  props<{ requestId?: string }>()
);

const clearUploadHistory = createAction('[File Upload] Clear Upload History');

const resetUploadState = createAction('[File Upload] Reset Upload State');

export const FileUploadActions = {
  generatePresignedUrl,
  generatePresignedUrlSuccess,
  generatePresignedUrlFailure,
  uploadFileToS3,
  uploadFileToS3Progress,
  uploadFileToS3Success,
  uploadFileToS3Failure,
  uploadFile,
  uploadFileSuccess,
  uploadFileFailure,
  clearUploadError,
  clearUploadHistory,
  resetUploadState,
};
